<template>
	<div class="insert_div">
		<el-form ref="form" :model="form" label-width="80px" style="width: 100%;">
				<el-row>
					<el-col :span="24"><h1>商户新增</h1></el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="商家编号">
							<el-input v-model="form.storeNo"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="所属社区">
							<el-input v-model="form.communityName"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="商户名称">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

			<el-row>
				<el-col :span="24">
					<el-form-item label="店铺图片">
						<!-- 上传组件 -->
						<!-- 图片上传成功的属性:on-success -->
						<el-upload
								style="text-align: left"
								class="avatar-uploader"
								:action="uploadUrl"
								:show-file-list="false"
								:on-success="handleAvatarSuccess"
								:before-upload="beforeAvatarUpload">
							<!-- 图片回显 -->
							<!-- <img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
							<el-image
									v-if="imageUrl"
									:src="imageUrl"
									class="avatar"
									fit="cover"></el-image>
							<!-- 没有图片的时候显示的+号 -->
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>

				<el-row>
					<el-col :span="24">
						<el-form-item label="商户类型">
							<el-radio-group v-model="form.type">
								<el-radio label="直营店">直营店</el-radio>
								<el-radio label="加盟店">加盟店</el-radio>
								<el-radio label="授权店">授权店</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
			  <el-row>
					<el-col :span="24">
						<el-form-item label="发展人">
							<el-input v-model="form.person"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="负责人">
							<el-input v-model="form.storeLeader"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="联系电话">
							<el-input v-model="form.tel"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="性别">
							<el-radio-group v-model="form.type">
								<el-radio label="男">男</el-radio>
								<el-radio label="女">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="商家地址">
							<el-input v-model="form.address"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="经度">
							<el-input placeholder="请输入经度" v-model="form.longitude" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="纬度">
								<el-input placeholder="请输入经度" v-model="form.latitude" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<div class="input_div" style="width: 100%; height: 400px;margin: 10px;">
							<baidu-map
									@click="clickMap"
									:scroll-wheel-zoom="true"
									:center="center"
									:zoom="zoom"
									class="bm-view">
							</baidu-map>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="主营品类">
							<el-input type="textarea" v-model="form.saleType"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item>
							<el-button type="primary" @click="insertHouse">立即创建</el-button>
							<el-button>取消</el-button>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
					</el-col>
				</el-row><el-row>
				<el-col :span="12">
				</el-col>
			</el-row>
		</el-form>
		<div>
			<baidu-map
					@click="clickMap"
					:scroll-wheel-zoom="true"
					:center="center"
					:zoom="zoom"
					class="bm-view">
			</baidu-map>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				//图片上传地址
				uploadUrl: "http://localhost:8888/house/file/upload",
				//图片回显地址
				imageUrl: "",
				//一个form表单，里面有多个属性,整个房屋信息
				form: {
					id: "6",
					storeNo: "JM00011",
					communityName: "茂陵依山居",
					name: "房建医院120茂陵依山居店",
					storeLevel: "五级",
					type: "加盟",
					userName: "0",
					person: "王福健",
					storeLeader: "方舒琦",
					sex: "女",
					tel: "17605315365",
					address: "济南市历下区茂陵山路3号山久水园门头房一楼",
					saleType: "",
					longitude: "117.08562",
					latitude: "36.675637"
				},
				//百度地图的中心点和缩放级别
				center: "深圳市",	//中心点
				zoom: 12	//缩放级别，最大值是15
			}
		},
		methods: {
			//点击百度地图
			clickMap(e){
				console.log(e)
				this.form.longitude = e.point.lng;
				this.form.latitude = e.point.lat;
			},
			//图片上传成功后的回调方法
			handleAvatarSuccess(response){
				console.log("图片上传成功了",response);
				//上传后的图片名称记录下来保存到数据库中
				this.form.image = response;
				//图片回显
				this.imageUrl = "http://localhost:8888/house/file/download?fileName="+response;
			},
			//新增房屋信息
			insertHouse(){
				//发axios请求后端接口
				this.axios({
					method: "POST",
					url: "http://localhost:8888/house/house/insert",
					data: this.form		//默认按json的格式提交
				}).then((result)=>{
					this.$message({
						  message: '房屋添加成功！',
						  type: 'success'
					});

					//清空数据,把form表单重置
					this.form={
						id: "",
						storeNo: "",
						communityName: "",
						name: "",
						storeLevel: "",
						type: "",
						userName: "",
						person: "",
						storeLeader: "",
						sex: "",
						tel: "",
						address: "",
						saleType: "",
						longitude: "",
						latitude: ""
					};
				}).catch(()=> {			//axios处理异常提示信息
					this.$message({
						  message: '服务器异常',
						  type: 'error'
					});
				})
			}
		}
	}
</script>

<style>
	.insert_div{
		padding: 0px 300px;
		width: 100% !important;
		box-sizing: border-box;
		overflow: scroll;
	}

	.input_div{
		display: flex;	/* 弹性布局 */
		flex-direction: row;	/* 弹性布局的方向：行排列 */
		align-items: center;	/* 交叉轴居中 */
		justify-content: flex-start;
	}

	.input_div span{
		margin: 10px;
	}

	/* 上传组件样式 */
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	  }
	  .avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	  }

	  .bm-view{
		width: 100%;
		height: 100%;
	  }
</style>
